import appConstants from "../../../../../appConstants";
import {NumericEditor}  from "../../../../dataGrid/cellEditors";
export default class GridConfig {
    constructor(configuration){
        const config = configuration || {};
        this.name = "GridConfiguration";
        this.config = GridConfig.getConfiguration(config);
    }
    static getConfiguration({featureFlags}) {
      return GridConfig.getDefaultConfiguration( featureFlags);
    }

    static getDefaultConfiguration(featureFlags) {
    return {
      title: appConstants.gridNames.TrailerInventory,
      keyColumn: "trailerName",
      enableFilters: false,
      enableSorting: false,
      columns: [
        {
          headerName: "Trailer ID",
          field: "trailerId",
          hide: true,
          headerTooltip: "Trailer ID"
        },
        {
          headerName: "Trailer Type",
          field: "trailerName",
          headerTooltip: "Trailer Type",
          minWidth:200
        },
        {
          headerName: "Max Skids",
          field: "maxSkidsAllowed",
          headerTooltip: "Max Skids Allowed",
          hide: Boolean(featureFlags.IsWeightBasedRoutingEnabled)
        },
        {
          headerName: "Max Weight",
          field: "maxWeight",
          headerTooltip: "Max Weight",
          hide: !Boolean(featureFlags.IsWeightBasedRoutingEnabled)
        },
        {
          headerName: "Available Count",
          field: "totalCount",
          headerTooltip: "Available Count",
        },
         {
          headerName: "Lift Gate",
          field: "isLiftGateRequired",
          headerTooltip: "Lift Gate",
        },
        {
          headerName:"Temp Type",
          field: "tempType",
          headerTooltip: "Temp Type",
          hide: !Boolean(featureFlags.showTempTypeTrailer)
        },
        {
          headerName: "Custom Value",
          field: "scenarioCount",
          headerTooltip: "Custom Value",
          editable: true,
          cellEditorFramework: NumericEditor
        }
      ]
    }
  }
}
